import { Fragment, h } from "preact";
import relativeUrl from "../helpers/relativeUrl";
import { CloseIcon, Spinner } from "../helpers/icons";

export default function FullDetails({
  url,
  text,
  className = "",
  tabindex = null,
}) {
  return (
    <product-details-drawer
      className={`${className}`}
      // Use uppercase to force this as an attribute instead of a property
      URL={relativeUrl(url)}
    >
      <button type="button" data-trigger tabindex={tabindex}>
        {text}
      </button>
      <div className="product-details-drawer" data-drawer>
        <button type="button" data-close aria-label="Close">
          <CloseIcon />
        </button>
        <div data-content></div>
      </div>
    </product-details-drawer>
  );
}
